import {
  SUPPLIER_LIST_REQUEST,
  SUPPLIER_LIST_SUCCESS,
  SUPPLIER_LIST_FAIL,
  SUPPLIER_LIST_RESET,
  SUPPLIER_SINGLE_REQUEST,
  SUPPLIER_SINGLE_SUCCESS,
  SUPPLIER_SINGLE_FAIL,
  SUPPLIER_SINGLE_RESET,
  POST_SUPPLIER_REQUEST,
  POST_SUPPLIER_SUCCESS,
  POST_SUPPLIER_FAIL,
  POST_SUPPLIER_RESET,
  UPDATE_SUPPLIER_REQUEST,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER_FAIL,
  UPDATE_SUPPLIER_RESET,
  DELETE_SUPPLIER_REQUEST,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAIL,
  DELETE_SUPPLIER_RESET,
} from "constants/supplierConstants";

export const listSuppliersReducer = (state = { suppliersList: [] }, action) => {
  switch (action.type) {
    case SUPPLIER_LIST_REQUEST:
      return { loading: true };
    case SUPPLIER_LIST_SUCCESS:
      return { loading: false, suppliersList: action.payload };
    case SUPPLIER_LIST_FAIL:
      return { loading: false, error: action.payload };
    case SUPPLIER_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const singleSuppliersReducer = (
  state = { suppliersSingle: [] },
  action
) => {
  switch (action.type) {
    case SUPPLIER_SINGLE_REQUEST:
      return { loading: true };
    case SUPPLIER_SINGLE_SUCCESS:
      return { loading: false, suppliersSingle: action.payload };
    case SUPPLIER_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case SUPPLIER_SINGLE_RESET:
      return [];
    default:
      return state;
  }
};

export const suppliersPostReducer = (state = { suppliers: {} }, action) => {
  switch (action.type) {
    case POST_SUPPLIER_REQUEST:
      return { loading: true };
    case POST_SUPPLIER_SUCCESS:
      return { loading: false, suppliers: action.payload };
    case POST_SUPPLIER_FAIL:
      return { loading: false, error: action.payload };
    case POST_SUPPLIER_RESET:
      return { suppliers: {} };
    default:
      return state;
  }
};

export const updateSuppliersReducer = (
  state = { suppliersUpdate: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_SUPPLIER_REQUEST:
      return { loading: true };
    case UPDATE_SUPPLIER_SUCCESS:
      return { loading: false, suppliersUpdate: action.payload, success: true };
    case UPDATE_SUPPLIER_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_SUPPLIER_RESET:
      return { suppliersUpdate: {} };
    default:
      return state;
  }
};

export const deleteSuppliersReducer = (
  state = { deleteSuppliers: {} },
  action
) => {
  switch (action.type) {
    case DELETE_SUPPLIER_REQUEST:
      return { loading: true };
    case DELETE_SUPPLIER_SUCCESS:
      return { loading: false, deleteSuppliers: action.payload, success: true };
    case DELETE_SUPPLIER_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_SUPPLIER_RESET:
      return { deleteSuppliers: {} };
    default:
      return state;
  }
};
